<hawk-record-navigation [breadcrumbLinkList]="[]" [root]="'user'" [leafDescription]="'Benutzer'" class="app-page">
  <div slot="toolbar" class="flex flex-row gap-2 items-center">
    <label class="whitespace-nowrap">
      <input type="checkbox" class="bm-checkbox" [(ngModel)]="onlyActiveUsers" (change)="updateShownUsers()" />
      Nur aktive Nutzer
    </label>
    <a [routerLink]="'/benutzer/neu'" class="bm-btn bm-btn-ghost">
      <i class="fa fa-plus"></i>
      Benutzer erstellen
    </a>
    <input type="text" class="bm-input" placeholder="Schnellfilter..." (input)="quickSearchChanged($event)" />
  </div>
  <div class="page-content px-4 pb-2">
    <ag-grid-angular
      class="ag-theme-quartz h-full rounded shadow-sm"
      [rowData]="shownUsers"
      [theme]="hawkTheme"
      [defaultColDef]="defaultColDef"
      [columnDefs]="colDefs"
      [rowClassRules]="rowClassRules"
      [pagination]="true"
      [rowSelection]="rowSelection"
      [autoSizeStrategy]="autoSizeStrategy"
      [paginationPageSize]="100"
      [localeText]="locale"
      [sideBar]="sideBarOptions"
      [paginationPageSizeSelector]="[25, 100, 250, 1000]"
      (gridReady)="onGridReady($event)"
    />
  </div>
</hawk-record-navigation>
